
    <div mat-dialog-content class="text-center">
        {{data}}
    </div>
    <div mat-dialog-actions class="row justify-content-center mt-3 mb-1">

        <button mat-raised-button class="btn" color="primary" (click)="onConfirm()">Ok</button>
        

    </div>